









































import IconPhonPinLock from '@/app/ui/assets/badge_phone_pin_lock.vue'
import Button from '@/app/ui/components/Button/index.vue'
import Teleport from '@/app/ui/components/Teleport/index.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  components: {
    Teleport,
    IconPhonPinLock,
    Button,
  },
})
class OTPActivationModal extends Vue {
  @Prop({default: false, type: Boolean, required: false}) public disabled!: boolean
}
export default OTPActivationModal;
